<strong class="suggested-results-description">Pesquisas sugeridas</strong>
<div class="cards-list" *ngIf="searchResultItems$ | async as searchResultItems">
  @if (isInvalidSearchTermLength) {
    <p>Digite ao menos 3 letras e aguarde os resultados</p>
  } @else if (isLoadingResults) {
    <ng-container *ngTemplateOutlet="loadingResultsContainer"></ng-container>
  } @else if (!hasResultItems(searchResultItems)) {
    <p>
      Não foram encontrados resultados que contenham “{{
        searchForm.get('searchTerm').value
      }}”
    </p>
  } @else {
    <ng-container *ngFor="let searchResultItem of searchResultItems">
      <app-search-result-card
        *ngIf="searchResultItem.isEligible !== false"
        [searchResult]="searchResultItem"
      ></app-search-result-card>
    </ng-container>
  }
</div>
<ng-template #loadingResultsContainer>
  <div class="skeleton-loading-card"></div>
  <div class="skeleton-loading-card"></div>
  <div class="skeleton-loading-card"></div>
</ng-template>
